const ListService = () => import('./modules/Service/pages/List');
const RegisterService = () => import('./modules/Service/pages/Register');

export default [
  {
    path: '/cadastre/services/new',
    name: 'Services',
    component: RegisterService,
    meta: {
      title: 'Serviços',
    },
  },
  {
    path: '/cadastre/services/edit/:id',
    name: 'InventoryServiceEdit',
    component: RegisterService,
    meta: {
      title: 'Serviços',
    },
  },
  {
    path: '/cadastre/services/:page?',
    name: 'Services',
    component: ListService,
    meta: {
      title: 'Serviços',
    },
  },
];
